<template>
  <div class="search">
    <el-form class="searchform" :class="{'search-hidden':search_hidden}" :style="{'height':search_height}" ref="form" :model="form" label-width="80px" label-position="left">
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">交易編號</label>
            <el-input v-model="form.businessnum" clearable placeholder=""></el-input>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">狀態</label>
            <el-select v-model="form.status" placeholder="全部">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="準備中 Pending" value="0"></el-option>
              <el-option label="已審批 Approved" value="1"></el-option>
              <el-option label="處理中 Processing" value="2"></el-option>
              <el-option label="已完成 Successful" value="3"></el-option>
              <el-option label="失敗 Fail" value="4"></el-option>
              <el-option label="已刪除 Deleted" value="5"></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">交易金額</label>
            <div class="mm-row">
              <div class="mm-col">
                <el-input type="number" v-model="form.startmoney" clearable></el-input>
              </div>
              <div class="mmline">-</div>
              <div class="mm-col">
                <el-input type="number" v-model="form.endmoney" clearable></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">貨幣</label>
            <el-select v-model="form.currency_id" placeholder="全部">
              <el-option label="全部" value="-1"></el-option>
              <el-option v-for="item in currencylist" :key="item.id" :label="item.name+' '+item.short_name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">開單時間</label>
            <div class="mm-row">
              <div class="mm-col">
                <el-date-picker type="date" placeholder="選擇日期" v-model="form.starttime" style="width: 100%;"></el-date-picker>
              </div>
              <div class="mmline">-</div>
              <div class="mm-col">
                <el-date-picker type="date" placeholder="選擇日期" v-model="form.endtime" style="width: 100%;"></el-date-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">交易方式</label>
            <el-select v-model="form.mode" placeholder="全部">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="現金" value="0"></el-option>
              <el-option label="銀行轉賬" value="1"></el-option>
              <el-option label="特別賬戶" value="2"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">關聯訂單</label>
            <el-input v-model="form.ordernum" clearable placeholder=""></el-input>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">備註</label>
            <el-input type="text" v-model="form.mark" clearable></el-input>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">開單員</label>
            <el-select :placeholder="'請選擇'" v-model="form.staff_id" width="100%">
              <el-option :label="$t('全部')" value="-1"></el-option>
              <el-option v-for="item in operators" :key="item.id" :label="item.username+'('+item.name+')'" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label"></label>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">排序字段</label>
            <el-select v-model="form.sortname" placeholder="全部">
              <el-option label="添加時間" value="addtime"></el-option>
              <el-option label="交易單編號" value="businessnum"></el-option>
              <el-option label="關聯訂單號" value="order_id"></el-option>
              <el-option label="交易單金額" value="money"></el-option>
              <el-option label="交易貨幣" value="currency_id"></el-option>
              <el-option label="交易方式" value="mode"></el-option>
              <el-option label="開單門市" value="store_id"></el-option>
              <el-option label="開單員工" value="staff_id"></el-option>
              <el-option label="狀態" value="status"></el-option>
              <el-option label="備註" value="mark"></el-option>
              <el-option label="ID" value="id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">排序方式</label>
            <div class="mm-row">
              <div class="flex-start">
                <el-radio v-model="form.orderby" label="DESC">由高到低</el-radio>
                <el-radio v-model="form.orderby" label="ASC">由低到高</el-radio>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mm-submitbox">
        <div>
          <el-button @click="submit(0)" type="primary" plain>清空</el-button>
          <el-button @click="submit(1)" type="warning" plain>刷新</el-button>
        </div>
      </div>
    </el-form>
    <div @click="changesearchbox" class="rowline">
      <div>
        <i class="mm-nav-arrow el-icon-arrow-down" style="font-size: 12px; margin-right: 5px;"></i><span>{{search_hidden_text}}</span>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: "Search",
  props: ['form'],
  data () {
    return {
      search_height: 0,
      search_hidden: true,
      search_hidden_text: '檢索展開',
      currencylist: [],
      storelist: [],
      sectorlist: [],
      operators: []
    }
  },
  methods: {
    submit (type) {
      this.form.mode = '-1';
      this.form.currency_id = '-1';
      this.form.status = '-1';
      this.form.startmoney = '';
      this.form.endmoney = '';
      this.form.starttime = '';
      this.form.endtime = '';
      this.form.businessnum = '';
      this.form.ordernum = '';
      this.form.mark = '';
      this.form.sortname = "addtime";
      this.form.orderby = "DESC";
      this.form.staff_id = '-1';
      if (type == 1) {
        this.form.type = '-1';
      }
    },
    getdata () {
      this.post('/api/order/order_search_data', {})
        .then(response => {
          if (response.currency.length > 0) {
            this.currencylist = response.currency;
          }

          if (response.store.length > 0) {
            this.storelist = response.store;
          }

          if (response.sector.length > 0) {
            this.sectorlist = response.sector;
          }

          if (response.operators.length > 0) {
            this.operators = response.operators;
          }
        }).catch(error => {
          console.log(error);
        });
    },
    changesearchbox () {
      let search_height = this.$refs.form.$el.scrollHeight + 'px';
      if (this.search_hidden) {
        this.search_hidden = false;
        this.search_hidden_text = '檢索隱藏';
        this.search_height = search_height;
        console.log();
      } else {
        this.search_hidden = true;
        this.search_hidden_text = '檢索展開'
        this.search_height = 0;
      }
    }
  },
  created () {
    this.getdata();
  }

}
</script>

<style scoped>
.search {
  margin-top: 20px;
}
.searchform {
  transition: height ease 0.3s;
  overflow: hidden;
}

.rowline {
  border-bottom: 1px solid #66b1ff;
  display: flex;
  justify-content: center;
  padding-bottom: 5px;
  color: #409eff;
  cursor: pointer;
}
.search-hidden {
  height: 0;
  overflow: hidden;
}
@media screen and (max-width: 1024px) {
  .mm-submitbox {
    display: flex;
    justify-content: flex-end;
  }
  .mm-row {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0;
  }
  .mm-col {
    flex: 1 100%;
    padding: 10px 0;
  }
  .mm-label {
    flex: 0 0 60px;
    padding-left: 0;
  }
}
</style>
